import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info-open",
  "use": "info-open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"info-open\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M12 21a9 9 0 110-18 9 9 0 010 18m0-20a11 11 0 100 22 11 11 0 000-22M12 11a1 1 0 00-1 1v4c0 .6.4 1 1 1s1-.4 1-1v-4c0-.6-.4-1-1-1M12 7a1 1 0 000 2 1 1 0 000-2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol